<template>
    <teleport to="#modal">
        <Loading
            :visible="loading"
        >
        </Loading>
    </teleport>
    <div class="m-auto px-8 md:px-20">
        <div class="max-w-screen-2xl m-auto">
            <div class="flex justify-between items-center py-10">
                <Switcher v-model="tab_show" :options="['Ordini di acquisto', 'Ordini di vendita']"></Switcher>
                <NextButton variant="primary" @click="visible=true"
                        class="ml-3 py-2 px-4 m-0 hidden sm:flex items-center">
                    + Aggiungi
                </NextButton>
            </div>
            <!--      <Grid :cols="cols" :rows="rows"></Grid>-->
            <div v-if="!tab_show">
                <div class="rotate-x-180 overflow-x-scroll">
                    <NextTable class="rotate-x-180 w-full border-separate border-spacing-3 py-4 pl-5" v-model:cols="cols"
                               :rows="rowsAcquisto" @order-update="void(0)">

                        <template v-for="(c, j) in rowsAcquisto" :key="j" v-slot:[`td_${j}_1`]="context">
                            {{ context.context.row.progetto.azienda.denominazione }}
                        </template>

                        <template v-for="(c, j) in rowsAcquisto" :key="j" v-slot:[`td_${j}_4`]="context">
                            {{ context.context.row.dati.budget_consuntivo }}
                        </template>

                        <template v-for="(c, j) in rowsAcquisto" :key="j" v-slot:[`td_${j}_5`]="context">
                            {{ context.context.row.dati.totale_costi }}
                        </template>

                        <template v-for="(c, j) in rowsAcquisto" :key="j" v-slot:[`td_${j}_6`]="context">
                            {{ context.context.row.dati.totale_ricavi }}
                        </template>

                        <template v-for="(c, j) in rowsAcquisto" :key="j" v-slot:[`td_${j}_7`]="context">
                            <router-link :to="{name:'DettaglioSottoProgetto', params:{id:context.context.row.id}}"
                                         class="block text-center inset-0 absolute flex items-center justify-center"><i class="icon-chevron_destra"></i></router-link>
                        </template>

                    </NextTable>
                </div>
                <InfiniteLoading @infinite="fetchNextAcquisto" :identifier="infiniteIdentifierAcquisto" style="min-height: 1px">
                    <template #complete>
                        <div class="text-center pb-3">Non ci sono altri clienti.</div>
                    </template>
                </InfiniteLoading>
            </div>
            <div v-else>
                <div class="rotate-x-180 overflow-x-scroll">
                    <NextTable class="rotate-x-180 w-full border-separate border-spacing-3 py-4 pl-5" v-model:cols="cols"
                               :rows="rowsVendita" @order-update="void(0)">

                        <template v-for="(c, j) in rowsVendita" :key="j" v-slot:[`td_${j}_1`]="context">
                            {{ context.context.row.progetto.azienda.denominazione }}
                        </template>

                        <template v-for="(c, j) in rowsVendita" :key="j" v-slot:[`td_${j}_4`]="context">
                            {{ context.context.row.dati.budget_consuntivo }}
                        </template>

                        <template v-for="(c, j) in rowsVendita" :key="j" v-slot:[`td_${j}_5`]="context">
                            {{ context.context.row.dati.totale_costi }}
                        </template>

                        <template v-for="(c, j) in rowsVendita" :key="j" v-slot:[`td_${j}_6`]="context">
                            {{ context.context.row.dati.totale_ricavi }}
                        </template>

                        <template v-for="(c, j) in rowsVendita" :key="j" v-slot:[`td_${j}_7`]="context">
                            <router-link :to="{name:'DettaglioSottoProgetto', params:{id:context.context.row.id}}"
                                         class="block text-center inset-0 absolute flex items-center justify-center"><i class="icon-chevron_destra"></i></router-link>
                        </template>

                    </NextTable>

                </div>
                <InfiniteLoading @infinite="fetchNextVendita" :identifier="infiniteIdentifierVendita" style="min-height: 1px">
                    <template #complete>
                        <div class="text-center pb-3">Non ci sono altri clienti.</div>
                    </template>
                </InfiniteLoading>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import AlertCard from "../components/AlertCard.vue";
import NextTable from "@/components/NextTable.vue";
import Paginator from "@/components/Paginator.vue";
import InfiniteLoading from "v3-infinite-loading";
import ConfermaModal from "@/components/ConfermaModal.vue";
import ContextMenu from "@/components/ContextMenu.vue";
import Loading from "@/components/Loading.vue";
import TopbarProgetti from "@/components/TopbarProgetti.vue";
import sottoProgettiManager from "../api/SottoProgetti";
import Switcher from "@/components/Switcher.vue";
import NextButton from "@/components/NextButton.vue";

@Options({
    name:'ListaOrdini',
    components: {
        NextButton,
        TopbarProgetti,
        AlertCard,
        NextTable,
        Paginator,
        InfiniteLoading,
        ConfermaModal,
        ContextMenu,
        Loading,
        Switcher,
    }
})
export default class ListaOrdini extends Vue {

    tab_show = 0
    loading = false
    visible = false

    sortAcquisto = false
    sortVendita = false

    rowsAcquisto: any[] = []
    rowsVendita: any[] = []

    paginatorAcquisto: any = {}
    paginatorVendita: any = {}
    infiniteIdentifierAcquisto = false
    infiniteIdentifierVendita = false

    mounted() {
        this.resetTableAcquisto()
        this.resetTableVendita()
    }

    resetTableAcquisto() {
        this.infiniteIdentifierAcquisto = !this.infiniteIdentifierAcquisto
        this.fetchAcquisto(1)
    }

    resetTableVendita() {
        this.infiniteIdentifierVendita = !this.infiniteIdentifierVendita
        this.fetchVendita(1)
    }

    default = {
        fee: [],
        rebate: [],
        budget_consuntivo: 0,
        totale_costi: 0,
        risorse_interne: 0,
        totale_ricavi: 0,
        utile: 0,
        margine: 0,
        sezioni: [
            {
                titolo: '',
                records: [{}]
            }
        ]
    }

    fetchAcquisto(page?: number) {
        this.loading = true
        return sottoProgettiManager.sottoprogetti({params:{page, sort: this.sortAcquisto}}).then((response) => {
            const {data, ...pag} = response.data;
            if (page && page > 1) {
                this.rowsAcquisto.push(...data)
            } else {
                this.rowsAcquisto.splice(0, this.rowsAcquisto.length, ...data)
            }
            this.rowsAcquisto = this.rowsAcquisto.map((el) => {
                return {...el, dati: {...this.default,...JSON.parse(el.ultimi_dati)} }
            })
            this.paginatorAcquisto = pag
        }).finally(() => {
            this.loading = false
        })
    }

    fetchVendita(page?: number) {
        this.loading = true
        return sottoProgettiManager.sottoprogetti({params:{page, sort: this.sortVendita}}).then((response) => {
            const {data, ...pag} = response.data;
            if (page && page > 1) {
                this.rowsVendita.push(...data)
            } else {
                this.rowsVendita.splice(0, this.rowsVendita.length, ...data)
            }
            this.rowsVendita = this.rowsVendita.map((el) => {
                return {...el, dati: {...this.default,...JSON.parse(el.ultimi_dati)} }
            })
            this.paginatorVendita = pag
        }).finally(() => {
            this.loading = false
        })
    }

    fetchNextAcquisto(state: any) {
        if (this.paginatorAcquisto.current_page) {
            if (this.paginatorAcquisto.current_page < this.paginatorAcquisto.last_page) {
                this.fetchAcquisto(++this.paginatorAcquisto.current_page).then(() => {
                    state.loaded()
                }).catch(() => {
                    state.error()
                })
            } else {
                state.complete()
            }
        } else {
            state.loaded()
        }
    }

    fetchNextVendita(state: any) {
        if (this.paginatorVendita.current_page) {
            if (this.paginatorVendita.current_page < this.paginatorVendita.last_page) {
                this.fetchAcquisto(++this.paginatorVendita.current_page).then(() => {
                    state.loaded()
                }).catch(() => {
                    state.error()
                })
            } else {
                state.complete()
            }
        } else {
            state.loaded()
        }
    }

    cols = [
        {
            name: 'Nome sottoprogetto',
            prop: 'titolo',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2',
            resizable: false
        },
        {
            name: 'Azienda',
            prop: 'azienda',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2',
            resizable: false
        },
        {
            name: 'Stato',
            prop: 'stato',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            resizable: false
        },
        {
            name: 'Budget preventivo',
            prop: 'budget_preventivo',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2',
            resizable: false
        },
        {
            name: 'Budget consuntivo',
            prop: 'budget_consuntivo',
            orderable: false,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2',
            resizable: false
        },
        {
            name: 'Costo',
            prop: 'costo',
            orderable: false,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2',
            resizable: false
        },
        {
            name: 'Ricavo',
            prop: 'ricavo',
            orderable: false,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2',
            resizable: false
        },
        {
            name: '',
            prop: '',
            orderable: false,
            class: 'min-w-10 w-10 whitespace-nowrap',
            td_class: 'relative hover:bg-next-orange hover:text-white',
            resizable: false
        }
    ]
}

</script>


<style lang="scss">

</style>
